import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

export const onClientEntry = () => {
  console.log("------------------------------------------------")
  console.log(
    "%c          Made by",
    'text-align: center; color: #006cff; font-size: 18px; font-family: "Roboto", sans-serif'
  )
  console.log(
    "%cInvisual Branding Solutions",
    'color: white ; font-size: 24px; font-family: "Roboto", sans-serif'
  )
  console.log("------------------------------------------------")
}

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
      language="pt"
    >
      {element}
    </GoogleReCaptchaProvider>
  )
}